export const User = `{
  id
  name
  firstName
  lastName
  email
  picture
  sub
}`
